import './UpdateViewButton.scss';
import React from 'react';
import { SaveFilled } from '@ant-design/icons';
import { useAction } from '@hooks';
import { ViewQueryParams } from './CreateView';
import { coreActions, DataDictionaryView } from '@sonar-software/sonar-core';

export interface UpdateViewButtonProps {
	queryParams: ViewQueryParams;
	view: DataDictionaryView;
}

export const UpdateViewButton: React.FC<UpdateViewButtonProps> = ({ queryParams, view }) => {
	const update = useAction(coreActions.requestPatchCoreDataDictionaryViews);

	const hasDifference =
		view.id === queryParams.lastViewId &&
		(view.columns !== queryParams.columns ||
			view.filter !== queryParams.filters ||
			view.ordering !== queryParams.ordering);

	if (!hasDifference) {
		return null;
	}

	return (
		<SaveFilled
			className='view-save-changes-icon'
			onClick={ (e) => {
				e.stopPropagation();

				update({
					columns: queryParams.columns ?? '',
					filter: queryParams.filters ?? '',
					ordering: queryParams.ordering ?? '',
					viewId: view.id
				});
			} } />
	);
};
